export const transactionDataResolverTestData = {
    'Bekreftet VISA': {
        amount: -150,
        count: 1,
        name: 'Bekreftet VISA',
    },
    'MUSTI.NO KCO V.3 RECUR': {
        amount: -788,
        count: 1,
        name: 'MUSTI.NO KCO V.3 RECUR',
    },
    'APPLE.COM/BILL': {
        amount: -3317,
        count: 23,
        name: 'APPLE.COM/BILL',
    },
    'HBO MAX': {
        amount: -44.5,
        count: 1,
        name: 'HBO MAX',
    },
    'Oda.com - 7vdhgg': {
        amount: -825.4,
        count: 3,
        name: 'Oda.com - 7vdhgg',
    },
    'WEORDER* DIGG PIZZA': {
        amount: -1110,
        count: 5,
        name: 'WEORDER* DIGG PIZZA',
    },
    Straksbetaling: {
        amount: 238,
        count: 2,
        name: 'Straksbetaling',
    },
    'Yandex.Taxi': {
        amount: -291,
        count: 1,
        name: 'Yandex.Taxi',
    },
    'ODEON KINO APP': {
        amount: -578,
        count: 1,
        name: 'ODEON KINO APP',
    },
    RUTERAPPEN: {
        amount: -167,
        count: 3,
        name: 'RUTERAPPEN',
    },
    'Oda.com - xnhxe5': {
        amount: -1175.16,
        count: 1,
        name: 'Oda.com - xnhxe5',
    },
    BUNNYCDN: {
        amount: -102.85,
        count: 1,
        name: 'BUNNYCDN',
    },
    'STEAMGAMES.COM 4259522985': {
        amount: -150,
        count: 1,
        name: 'STEAMGAMES.COM 4259522985',
    },
    'Kygo 2022 / Sky Agency': {
        amount: -363,
        count: 2,
        name: 'Kygo 2022 / Sky Agency',
    },
    'UDEMY: ONLINE COURSES': {
        amount: -129,
        count: 1,
        name: 'UDEMY: ONLINE COURSES',
    },
    TRADINGVIEW1PRODUCT: {
        amount: -153.52,
        count: 1,
        name: 'TRADINGVIEW1PRODUCT',
    },
    RUTERBILLETT: {
        amount: -39,
        count: 1,
        name: 'RUTERBILLETT',
    },
};

export const transactionResolverTestData = {
    availableItems: 105,
    items: [
        {
            accountingDate: '2022-07-29T00:00:00',
            interestDate: '2022-07-29T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -150,
            text: 'SYNG PENT',
            transactionType: 'Bekreftet VISA',
            transactionTypeCode: 946,
            transactionTypeText: '',
            isReservation: true,
            reservationType: 'VisaReservation',
            source: 'AccountStatement',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-29T00:00:00',
            interestDate: '2022-07-29T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -220,
            text: 'EXTRA NEUBERGGT',
            transactionType: 'Varekjøp',
            transactionTypeCode: 943,
            transactionTypeText: '',
            isReservation: true,
            reservationType: 'PurchaseReservation',
            source: 'AccountStatement',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-28T00:00:00',
            interestDate: '2022-07-28T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -197.4,
            text: '27.07 EXTRA NEUBERGGT NEUBERGGATA  OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-28T00:00:00',
            interestDate: '2022-07-28T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -788,
            text: '27.07 NOK 788.00 MUSTI.NO KCO V.3 RECUR Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 788,
                currencyRate: 1,
                merchantCategoryCode: '5995',
                merchantCategoryDescription: 'Dyrebutikk',
                merchantCity: 'INTERNET',
                merchantName: 'MUSTI.NO KCO V.3 RECUR',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-27T00:00:00',
                transactionId: '4822082814669130',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-28T00:00:00',
            interestDate: '2022-07-29T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -269,
            text: '27.07 NOK 269.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 269,
                currencyRate: 1,
                merchantCategoryCode: '5818',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-27T00:00:00',
                transactionId: '4822083734035600',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-28T00:00:00',
            interestDate: '2022-07-29T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -109,
            text: '27.07 NOK 109.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 109,
                currencyRate: 1,
                merchantCategoryCode: '5735',
                merchantCategoryDescription: 'Musikk',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-27T00:00:00',
                transactionId: '4822087704132050',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-27T00:00:00',
            interestDate: '2022-07-28T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -44.5,
            text: '26.07 NOK 44.50 HBO MAX Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 44.5,
                currencyRate: 1,
                merchantCategoryCode: '5968',
                merchantCategoryDescription: 'Postordre, telemarketing mm',
                merchantCity: 'Stockholm',
                merchantName: 'HBO MAX',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-26T00:00:00',
                transactionId: '4822076142801600',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-27T00:00:00',
            interestDate: '2022-07-27T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -250,
            text: 'Til: Sandra berg',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-26T00:00:00',
            interestDate: '2022-07-27T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -55,
            text: '25.07 NOK 55.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 55,
                currencyRate: 1,
                merchantCategoryCode: '5735',
                merchantCategoryDescription: 'Musikk',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-25T00:00:00',
                transactionId: '4822062357162560',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-26T00:00:00',
            interestDate: '2022-07-26T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -2000,
            text: 'Til: Sander berg',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-26T00:00:00',
            interestDate: '2022-07-27T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -329,
            text: '25.07 NOK 329.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 329,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-25T00:00:00',
                transactionId: '4822062330417720',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-25T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -802.9,
            text: '22.07 NOK 802.90 Oda.com - 7vdhgg Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 802.9,
                currencyRate: 1,
                merchantCategoryCode: '5411',
                merchantCategoryDescription: 'Dagligvarer',
                merchantCity: 'Oslo',
                merchantName: 'Oda.com - 7vdhgg',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-22T00:00:00',
                transactionId: '4822026273588610',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-25T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -104,
            text: "23.07 MCDONALD'S 005  VALKYRIEGATE OSLO",
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-25T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -193.1,
            text: '25.07 KIWI 381 SORGEN SORGENFRIGAT OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-25T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -37.4,
            text: '22.07 NOK 37.40 Oda.com - 7vdhgg Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 37.4,
                currencyRate: 1,
                merchantCategoryCode: '5411',
                merchantCategoryDescription: 'Dagligvarer',
                merchantCity: 'Oslo',
                merchantName: 'Oda.com - 7vdhgg',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-22T00:00:00',
                transactionId: '4822026276744570',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-25T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -244.9,
            text: '23.07 EXTRA NEUBERGGT NEUBERGGATA  OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-25T00:00:00',
            interestDate: '2022-07-22T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 14.9,
            text: '22.07 NOK 14.90 Oda.com - 7vdhgg Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 14.9,
                currencyRate: 1,
                merchantCategoryCode: '5411',
                merchantCategoryDescription: 'Dagligvarer',
                merchantCity: 'Oslo',
                merchantName: 'Oda.com - 7vdhgg',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-22T00:00:00',
                transactionId: '4822026273588610',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-25T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -99,
            text: '22.07 EXTRA NEUBERGGT NEUBERGGATA  OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-25T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -22.9,
            text: '23.07 JOKER VALKYRIEN BOGSTADVEIEN OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-22T00:00:00',
            interestDate: '2022-07-22T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -700,
            text: 'Til: kari nordmann',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-22T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -109,
            text: '21.07 NOK 109.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 109,
                currencyRate: 1,
                merchantCategoryCode: '5735',
                merchantCategoryDescription: 'Musikk',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-21T00:00:00',
                transactionId: '4822027060045300',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-22T00:00:00',
            interestDate: '2022-07-25T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -55,
            text: '21.07 NOK 55.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 55,
                currencyRate: 1,
                merchantCategoryCode: '5735',
                merchantCategoryDescription: 'Musikk',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-21T00:00:00',
                transactionId: '4822022083238360',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-22T00:00:00',
            interestDate: '2022-07-22T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 100,
            text: 'Fra: kari nordmann',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-22T00:00:00',
            interestDate: '2022-07-22T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 1500,
            text: 'Fra: Stian berg Betalt: 21.07.22',
            transactionType: 'OVERFØRT',
            transactionTypeCode: 14,
            transactionTypeText: 'OVERFØRT',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-22T00:00:00',
            interestDate: '2022-07-22T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 300,
            text: 'Fra: kari nordmann',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-21T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -625,
            text: '20.07 NOK 625.00 WEORDER* DIGG PIZZA Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 625,
                currencyRate: 1,
                merchantCategoryCode: '5812',
                merchantCategoryDescription: 'Restaurant, spisested',
                merchantCity: 'OSLO',
                merchantName: 'WEORDER* DIGG PIZZA',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-20T00:00:00',
                transactionId: '4822016550533970',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-21T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 129,
            text: 'Fra: Havi Sossa',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-21T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -90,
            text: '20.07 MARIENLYST MINI KIRKEVN.92 OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-21T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -30,
            text: '20.07 MARIENLYST MINI KIRKEVN.92 OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-21T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 109,
            text: 'Fra: Salar berg',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-21T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 129,
            text: 'Vipps 20220720 20:07',
            transactionType: 'STRAKSBET',
            transactionTypeCode: 197,
            transactionTypeText: 'STRAKSBET',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-21T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 109,
            text: 'Pizza 20220720 20:36',
            transactionType: 'STRAKSBET',
            transactionTypeCode: 197,
            transactionTypeText: 'STRAKSBET',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-21T00:00:00',
            interestDate: '2022-07-22T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -329,
            text: '20.07 NOK 329.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 329,
                currencyRate: 1,
                merchantCategoryCode: '5735',
                merchantCategoryDescription: 'Musikk',
                merchantCity: 'CORK',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-20T00:00:00',
                transactionId: '4822012151310890',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-20T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -109,
            text: '20.07 NOK 109.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 109,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-20T00:00:00',
                transactionId: '4822005601098140',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-20T00:00:00',
            interestDate: '2022-07-20T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -36,
            text: '19.07 ODEON OSLO VITAMINVEIEN OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-20T00:00:00',
            interestDate: '2022-07-20T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -354.5,
            text: '20.07 EXTRA NEUBERGGT NEUBERGGATA  OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-20T00:00:00',
            interestDate: '2022-07-21T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -159,
            text: '19.07 NOK 159.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 159,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-19T00:00:00',
                transactionId: '4822002249301810',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-20T00:00:00',
            interestDate: '2022-07-20T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -89,
            text: '19.07 ODEON OSLO VITAMINVEIEN OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-19T00:00:00',
            interestDate: '2022-07-19T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -290,
            text: 'Til: Erik Nordmann',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-19T00:00:00',
            interestDate: '2022-07-19T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -850,
            text: 'Til: kari nordmann',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -269,
            text: '15.07 NOK 269.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 269,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-15T00:00:00',
                transactionId: '4821967395939140',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-19T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -291,
            text: '17.07 NOK 291.00 Yandex.Taxi Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 291,
                currencyRate: 1,
                merchantCategoryCode: '4121',
                merchantCategoryDescription: 'Taxi',
                merchantCity: 'Amsterdam',
                merchantName: 'Yandex.Taxi',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-17T00:00:00',
                transactionId: '4621980186076800',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 580,
            text: 'Fra: Erik Andre Berg',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -275,
            text: '15.07 PRIVAT RESTAURA STORGATA 4 KONGSBERG',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -279,
            text: '15.07 NETTBUSS TRAVEL BISKOP GUNNE OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -47,
            text: '15.07 MIX SKØYEN ST.  DRAMMENSVEIE OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -228,
            text: '16.07 NOK 228.00 WEORDER* DIGG PIZZA Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 228,
                currencyRate: 1,
                merchantCategoryCode: '5812',
                merchantCategoryDescription: 'Restaurant, spisested',
                merchantCity: 'OSLO',
                merchantName: 'WEORDER* DIGG PIZZA',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-16T00:00:00',
                transactionId: '4821975732167500',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 800,
            text: 'Fra: Stian berg Betalt: 18.07.22',
            transactionType: 'OVERFØRT',
            transactionTypeCode: 14,
            transactionTypeText: 'OVERFØRT',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -578,
            text: '17.07 NOK 578.00 ODEON KINO APP Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 578,
                currencyRate: 1,
                merchantCategoryCode: '7832',
                merchantCategoryDescription: 'Kino',
                merchantCity: 'OSLO',
                merchantName: 'ODEON KINO APP',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-17T00:00:00',
                transactionId: '4821983097707480',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 500,
            text: 'Fra: kari nordmann',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -142.8,
            text: '18.07 KIWI 381 SORGEN SORGENFRIGAT OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -208.2,
            text: '16.07 EXTRA NEUBERGGT NEUBERGGATA  OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-18T00:00:00',
            interestDate: '2022-07-18T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -159,
            text: '15.07 NOK 159.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 159,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-15T00:00:00',
                transactionId: '4821964509028130',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-15T00:00:00',
            interestDate: '2022-07-15T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -39,
            text: '13.07 NOK 39.00 RUTERAPPEN Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 39,
                currencyRate: 1,
                merchantCategoryCode: '4111',
                merchantCategoryDescription: 'Transport/billett',
                merchantCity: 'OSLO',
                merchantName: 'RUTERAPPEN',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-13T00:00:00',
                transactionId: '4821943098666410',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-15T00:00:00',
            interestDate: '2022-07-15T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 800,
            text: 'Fra: Stian berg Betalt: 15.07.22',
            transactionType: 'OVERFØRT',
            transactionTypeCode: 14,
            transactionTypeText: 'OVERFØRT',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-14T00:00:00',
            interestDate: '2022-07-15T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -109,
            text: '14.07 NOK 109.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 109,
                currencyRate: 1,
                merchantCategoryCode: '5818',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-14T00:00:00',
                transactionId: '4821946877020210',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-14T00:00:00',
            interestDate: '2022-07-14T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -64,
            text: '12.07 NOK 64.00 RUTERAPPEN Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 64,
                currencyRate: 1,
                merchantCategoryCode: '4111',
                merchantCategoryDescription: 'Transport/billett',
                merchantCity: 'OSLO',
                merchantName: 'RUTERAPPEN',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-12T00:00:00',
                transactionId: '4821932430208300',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-14T00:00:00',
            interestDate: '2022-07-14T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -64,
            text: '12.07 NOK 64.00 RUTERAPPEN Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 64,
                currencyRate: 1,
                merchantCategoryCode: '4111',
                merchantCategoryDescription: 'Transport/billett',
                merchantCity: 'OSLO',
                merchantName: 'RUTERAPPEN',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-12T00:00:00',
                transactionId: '4821934269716510',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-14T00:00:00',
            interestDate: '2022-07-15T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -11,
            text: '13.07 NOK 11.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 11,
                currencyRate: 1,
                merchantCategoryCode: '5735',
                merchantCategoryDescription: 'Musikk',
                merchantCity: '80056952',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-13T00:00:00',
                transactionId: '4821946891365200',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-13T00:00:00',
            interestDate: '2022-07-14T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -219,
            text: '12.07 NOK 219.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 219,
                currencyRate: 1,
                merchantCategoryCode: '5818',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-12T00:00:00',
                transactionId: '4821934830749970',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-13T00:00:00',
            interestDate: '2022-07-13T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -55.9,
            text: '13.07 JOKER VALKYRIEN BOGSTADVEIEN OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-12T00:00:00',
            interestDate: '2022-07-12T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 500,
            text: 'Fra: kari nordmann',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-12T00:00:00',
            interestDate: '2022-07-12T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -46,
            text: '12.07 CIRCLE K E6 BER BØLERVEIEN FROGNER',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-12T00:00:00',
            interestDate: '2022-07-12T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -355.8,
            text: '11.07 MUSTI BOGSTADVN BOGSTADVEIEN OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-12T00:00:00',
            interestDate: '2022-07-12T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -269.9,
            text: '11.07 CLAS OHL 2875 BOGSTADVEIEN OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-12T00:00:00',
            interestDate: '2022-07-12T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -350.7,
            text: '11.07 KIWI 381 SORGEN SORGENFRIGAT OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-12T00:00:00',
            interestDate: '2022-07-12T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -114,
            text: "12.07 MCDONALD'S 005  VALKYRIEGATE OSLO",
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-11T00:00:00',
            interestDate: '2022-07-11T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 1200,
            text: 'Fra: Stian berg Betalt: 11.07.22',
            transactionType: 'OVERFØRT',
            transactionTypeCode: 14,
            transactionTypeText: 'OVERFØRT',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-11T00:00:00',
            interestDate: '2022-07-11T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -19,
            text: '10.07 NOK 19.00 WEORDER* DIGG PIZZA Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 19,
                currencyRate: 1,
                merchantCategoryCode: '5812',
                merchantCategoryDescription: 'Restaurant, spisested',
                merchantCity: 'OSLO',
                merchantName: 'WEORDER* DIGG PIZZA',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-10T00:00:00',
                transactionId: '4821915422345470',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-11T00:00:00',
            interestDate: '2022-07-11T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -159,
            text: '08.07 NOK 159.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 159,
                currencyRate: 1,
                merchantCategoryCode: '5818',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-08T00:00:00',
                transactionId: '4821892107870730',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-07T00:00:00',
            interestDate: '2022-07-07T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -1175.16,
            text: '06.07 NOK 1175.16 Oda.com - xnhxe5 Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 1175.16,
                currencyRate: 1,
                merchantCategoryCode: '5411',
                merchantCategoryDescription: 'Dagligvarer',
                merchantCity: 'Oslo',
                merchantName: 'Oda.com - xnhxe5',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-06T00:00:00',
                transactionId: '4821865961388610',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-07T00:00:00',
            interestDate: '2022-07-08T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -109,
            text: '06.07 NOK 109.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 109,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-06T00:00:00',
                transactionId: '4821866029369430',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-07T00:00:00',
            interestDate: '2022-07-08T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -102.85,
            text: '06.07 USD 10.00 BUNNYCDN Kurs: 10.2850',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 10,
                currencyRate: 10.285,
                merchantCategoryCode: '5734',
                merchantCategoryDescription: 'PC programvare',
                merchantCity: 'MEDVODE',
                merchantName: 'BUNNYCDN',
                originalCurrencyCode: 'USD',
                purchaseDate: '2022-07-06T00:00:00',
                transactionId: '4821872998201870',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-07T00:00:00',
            interestDate: '2022-07-08T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -11,
            text: '06.07 NOK 11.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 11,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-06T00:00:00',
                transactionId: '4821877823945280',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-07T00:00:00',
            interestDate: '2022-07-08T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -11,
            text: '06.07 NOK 11.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 11,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-06T00:00:00',
                transactionId: '4821877666568740',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-07T00:00:00',
            interestDate: '2022-07-08T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -109,
            text: '06.07 NOK 109.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 109,
                currencyRate: 1,
                merchantCategoryCode: '5818',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-06T00:00:00',
                transactionId: '4821877644553210',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-06T00:00:00',
            interestDate: '2022-07-06T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -99,
            text: '05.07 EXTRA NEUBERGGT NEUBERGGATA  OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-06T00:00:00',
            interestDate: '2022-07-06T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -130.4,
            text: '05.07 EXTRA NEUBERGGT NEUBERGGATA  OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-06T00:00:00',
            interestDate: '2022-07-07T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -55,
            text: '04.07 NOK 55.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 55,
                currencyRate: 1,
                merchantCategoryCode: '5735',
                merchantCategoryDescription: 'Musikk',
                merchantCity: 'CORK',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-04T00:00:00',
                transactionId: '4821855976951840',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-05T00:00:00',
            interestDate: '2022-07-05T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -350,
            text: 'Til: Sandra berg',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-05T00:00:00',
            interestDate: '2022-07-05T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -119,
            text: '04.07 NOK 119.00 WEORDER* DIGG PIZZA Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 119,
                currencyRate: 1,
                merchantCategoryCode: '5812',
                merchantCategoryDescription: 'Restaurant, spisested',
                merchantCity: 'OSLO',
                merchantName: 'WEORDER* DIGG PIZZA',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-04T00:00:00',
                transactionId: '4821855604066460',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-05T00:00:00',
            interestDate: '2022-07-05T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -67.7,
            text: '05.07 JOKER VALKYRIEN BOGSTADVEIEN OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-05T00:00:00',
            interestDate: '2022-07-05T00:00:00',
            otherAccountNumberSpecified: false,
            amount: 1350,
            text: 'Fra: Nikolas nordmann',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-05T00:00:00',
            interestDate: '2022-07-06T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -85,
            text: '04.07 NOK 85.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 85,
                currencyRate: 1,
                merchantCategoryCode: '5815',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-04T00:00:00',
                transactionId: '4821855490705670',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -150,
            text: '01.07 NOK 150.00 STEAMGAMES.COM 4259522985 Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 150,
                currencyRate: 1,
                merchantCategoryCode: '5816',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'Hamburg',
                merchantName: 'STEAMGAMES.COM 4259522985',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-01T00:00:00',
                transactionId: '4821812662186850',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -134,
            text: "03.07 MCDONALD'S 005  VALKYRIEGATE OSLO",
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -137.4,
            text: '02.07 EXTRA NEUBERGGT NEUBERGGATA  OSLO',
            transactionType: 'VARER',
            transactionTypeCode: 710,
            transactionTypeText: 'VARER',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -329,
            text: '02.07 NOK 329.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 329,
                currencyRate: 1,
                merchantCategoryCode: '5818',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-02T00:00:00',
                transactionId: '4821833750772580',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -1000,
            text: 'Verdipapirhandel Sbanken',
            transactionType: 'FIN.INSTR',
            transactionTypeCode: 511,
            transactionTypeText: 'FIN.INSTR',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -139,
            text: '02.07 NOK 139.00 Kygo 2022 / Sky Agency Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 139,
                currencyRate: 1,
                merchantCategoryCode: '5812',
                merchantCategoryDescription: 'Restaurant, spisested',
                merchantCity: 'Gressvik',
                merchantName: 'Kygo 2022 / Sky Agency',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-02T00:00:00',
                transactionId: '4821836165170390',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -159,
            text: '01.07 NOK 159.00 APPLE.COM/BILL Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 159,
                currencyRate: 1,
                merchantCategoryCode: '5818',
                merchantCategoryDescription: 'Digitale tjenester',
                merchantCity: 'ITUNES.COM',
                merchantName: 'APPLE.COM/BILL',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-01T00:00:00',
                transactionId: '4821817778779380',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -129,
            text: '02.07 NOK 129.00 UDEMY: ONLINE COURSES Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 129,
                currencyRate: 1,
                merchantCategoryCode: '8299',
                merchantCategoryDescription: 'Diverse utdanning',
                merchantCity: 'HTTPSWWW.UDEM',
                merchantName: 'UDEMY: ONLINE COURSES',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-02T00:00:00',
                transactionId: '3821834698251390',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -153.52,
            text: '02.07 USD 14.95 TRADINGVIEW1PRODUCT Kurs: 10.2689',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 14.95,
                currencyRate: 10.2689,
                merchantCategoryCode: '5045',
                merchantCategoryDescription: 'PC og PC utstyr',
                merchantCity: '6142853455',
                merchantName: 'TRADINGVIEW1PRODUCT',
                originalCurrencyCode: 'USD',
                purchaseDate: '2022-07-02T00:00:00',
                transactionId: '4621835062987320',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -224,
            text: '02.07 NOK 224.00 Kygo 2022 / Sky Agency Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 224,
                currencyRate: 1,
                merchantCategoryCode: '5812',
                merchantCategoryDescription: 'Restaurant, spisested',
                merchantCity: 'Gressvik',
                merchantName: 'Kygo 2022 / Sky Agency',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-02T00:00:00',
                transactionId: '4821836162027500',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -119,
            text: '01.07 NOK 119.00 WEORDER* DIGG PIZZA Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 119,
                currencyRate: 1,
                merchantCategoryCode: '5812',
                merchantCategoryDescription: 'Restaurant, spisested',
                merchantCity: 'OSLO',
                merchantName: 'WEORDER* DIGG PIZZA',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-01T00:00:00',
                transactionId: '4821827040201980',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-04T00:00:00',
            interestDate: '2022-07-04T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -39,
            text: '02.07 NOK 39.00 RUTERBILLETT Kurs: 1.0000',
            transactionType: 'VISA VARE',
            transactionTypeCode: 714,
            transactionTypeText: 'VISA VARE',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: true,
            cardDetails: {
                cardNumber: '',
                currencyAmount: 39,
                currencyRate: 1,
                merchantCategoryCode: '4111',
                merchantCategoryDescription: 'Transport/billett',
                merchantCity: 'OSLO',
                merchantName: 'RUTERBILLETT',
                originalCurrencyCode: 'NOK',
                purchaseDate: '2022-07-02T00:00:00',
                transactionId: '4821835937665550',
            },
            transactionDetailSpecified: false,
        },
        {
            accountingDate: '2022-07-01T00:00:00',
            interestDate: '2022-07-01T00:00:00',
            otherAccountNumberSpecified: false,
            amount: -600,
            text: 'Til: Leo Berg',
            transactionType: 'StraksOvf',
            transactionTypeCode: 561,
            transactionTypeText: 'StraksOvf',
            isReservation: false,
            reservationType: null,
            source: 'Archive',
            cardDetailsSpecified: false,
            transactionDetailSpecified: false,
        },
    ],
};

export const accountResolverTestData = [
    {
        accountId: 'F961B90E978B0ACA8D603D331BFAD250',
        accountNumber: '1234 5678 910',
        ownerCustomerId: '16119700000',
        name: 'Test konto',
        accountType: 'Standard account',
        available: 14625,
        balance: 14995,
        creditLimit: 0,
    },
];
